module.exports = "https://static.cdns.space/qurangrowth-temp/img/m3.e2145b39.webp";